import { EmbedHtmlBlockService } from '@blocksuite/blocks';

export class PiqueEmbedHtmlBlockService extends EmbedHtmlBlockService {
  override mounted(): void {
    super.mounted();
  }
}
